import type { Translations } from './types';

const nl: Translations = {
    next: 'Volgende',
    storyReadPrompt: 'Lees alsjeblieft eerst het verhaal.',
    backToStory: '← Terug naar het verhaal',
    nextArrow: 'Volgende →',
    finishAssessment: 'Beoordeling afronden →',
    common_step: 'Stap',

    questionsStory1: 'Vragen — Verhaal 1',
    questionsStory2: 'Vragen — Verhaal 2',
    lastSetOfQuestions: 'Laatste set vragen — bijna klaar! 🎉',
    typeAnswerHere: 'Typ hier je antwoord...',
    backCountSingular: '📖 Je bent {n} keer teruggekeerd naar deze pagina om het verhaal te herlezen.',
    backCountPlural: '📖 Je bent {n} keer teruggekeerd naar deze pagina om het verhaal te herlezen.',

    assessmentComplete: 'Beoordeling voltooid! 🎉',
    assessmentSubtitle: 'Je hebt een belangrijke stap gezet in het begrijpen van leerstoornissen',
    returnToHome: 'Terug naar huis',
    assessmentSuccessfullyCompleted: 'Beoordeling succesvol voltooid',
    amazingJob: 'Geweldig gedaan!',
    youCrushedIt: 'Je hebt het geweldig gedaan! Dit heb je bereikt:',
    whatsNext: 'Wat nu?',
    getReadyForResults: 'Maak je klaar voor je gepersonaliseerde resultaten',
    youDidIt: 'Je hebt het gedaan!',
    youDidItDesc:
      'Jouw toewijding aan het begrijpen van leerstoornissen is echt inspirerend. Terwijl anderen het misschien hadden opgegeven, heb jij het tot het einde volgehouden!',

    heroLine1: 'DYSLEXIE',
    heroLine2: 'SCREENING',
    heroTagline: 'in één sessie',
    heroSubtitle:
      'Een multimodaal assessment in de browser dat je een schriftelijk rapport geeft zodra je klaar bent — geen kliniekbezoek, geen wachtlijst, geen speciale apparatuur.',
    heroBetaLabel: 'BÈTA',
    startAssessment: 'Nu starten',
    trustedBy: 'Vertrouwd door opvoeders en onderzoekers wereldwijd',

    pfp_privacyBadge: 'Privacy & Naleving',
    pfp_privacyHeading: 'We nemen gegevensbescherming serieus met volledige AVG- en MDR-naleving',
    pfp_formBadge: 'Start uw beoordeling',
    pfp_ctaHeading: 'DYSLEXIE SCREENING',
    pfp_ctaDesc: 'Sluit je aan bij duizenden die unieke inzichten in hun leesstijl hebben ontdekt via onze AI-gestuurde beoordeling.',
    pfp_ctaFooter: 'Geen tijdslimiet • Op uw eigen tempo • 100% vertrouwelijk',
    pfp_whyTitle: 'Waarom DysTest?',
    pfp_whySubtitle: 'Ontdek wat onze AI-gestuurde beoordeling de meest nauwkeurige en betrouwbare oplossing maakt',
    pfp_whyDesc: 'DysTest combineert meer dan 20 jaar professionele expertise in dyslexie-onderzoek met een leven lang ervaring. Door te reconstrueren hoe dyslectische en neurotypische lezers tekst verwerken, leert onze AI subtiele leespatronen te onderscheiden die traditionele tests missen.',
    pfp_feature1Title: 'Oogbewegingen, toetsaanslagen & meertalige inzichten',
    pfp_feature1Desc: 'Geavanceerde AI analyseert oogbewegingen, gezichtsuitdrukkingen en toetsaanslagen om leerpatronen te onthullen die uniek zijn voor elke lezer — in elke taal. DysTest past zich intelligent aan voor meertalige gebruikers voor precieze, gepersonaliseerde inzichten.',
    pfp_feature2Title: 'Onmiddellijke, Toepasbare Resultaten',
    pfp_feature2Desc: 'Krijg duidelijke, wetenschappelijk onderbouwde inzichten binnen minuten. Onze rapporten vertalen complexe gegevens naar begrijpelijke aanbevelingen die ouders, opvoeders en leerlingen meer mogelijkheden geven.',
    pfp_feature3Title: 'Privacy & Naleving Eerst',
    pfp_feature3Desc: 'Uw gegevens zijn versleuteld, geanonimiseerd en behandeld volgens de hoogste ethische en regelgevende normen — volledig conform AVG en MDR. Niets wordt gedeeld of gebruikt buiten het verbeteren van uw DysTest-ervaring.',
    pfp_feature4Title: 'Toegankelijk, Mensegericht Ontwerp',
    pfp_feature4Desc: 'DysTest laat u screenen op uw eigen tempo — rustig, intuïtief en zonder druk. Ontworpen voor inclusiviteit, toegankelijkheid en zinvol begrip, herdefiniëert het hoe leerstoornissen worden ontdekt en ondersteund.',
    pfp_finalCtaDesc: 'Begin vandaag uw gepersonaliseerde AI-gestuurde dyslexie screening — ontworpen om te begrijpen hoe u leest, niet alleen wat u leest.',

    hiw_badge: 'Eenvoudig 8-stappen proces',
    hiw_heading: 'Hoe de beoordeling werkt',
    hiw_subtext: 'Van registratie tot een gedetailleerd dyslexie beoordelingsrapport — volledig in de browser, geen downloads vereist.',
    hiw_step1Title: 'Registreren',
    hiw_step1Desc: 'Voer uw naam, leeftijd en voorkeurstaal in. Geen account vereist — duurt minder dan 2 minuten.',
    hiw_step2Title: 'Oogkalibratie',
    hiw_step2Desc: 'Volg 16 geanimeerde stippen over het scherm. De AI iris tracker leert uw unieke blikhandtekening.',
    hiw_step3Title: 'Woorden & Afbeeldingen',
    hiw_step3Desc: 'Koppel woorden aan hun afbeeldingen terwijl we herkenningssnelheid en visueel-fonologische verwerking meten.',
    hiw_step4Title: 'RAN-snelheidstest',
    hiw_step4Desc: 'Noem zo snel mogelijk een reeks kleuren of objecten hardop. Meet de terugvindfluïditeit.',
    hiw_step5Title: 'Verhalen & Vragen',
    hiw_step5Desc: 'Lees twee leeftijdsgeschikte verhalen en beantwoord begripsvragen. Oogbewegingen en knipperingen worden geregistreerd.',
    hiw_step6Title: 'Woorden schrijven',
    hiw_step6Desc: 'Typ woorden uit het geheugen. Toetsaanslagtijden en foutenpatronen tonen spellings- en motorische verwerking.',
    hiw_step7Title: 'Feedback',
    hiw_step7Desc: 'Deel uw ervaringen en zorgen. Deze context helpt de klinische interpretatie te kalibreren.',
    hiw_step8Title: 'Resultaten bekijken',
    hiw_step8Desc: 'Ontvang een gedetailleerd rapport met dyslexie-risico-indicatoren, blikheatmaps en leesmetrieken.',

    pf_whoTaking: 'Wie doet de test?',
    pf_myself: 'Ikzelf',
    pf_myselfAge: 'Leeftijd 13+',
    pf_child: 'Kind',
    pf_childAgeRange: 'Leeftijd 5-12',
    pf_verifyEmailTitle: 'Verifieer uw e-mail',
    pf_parentalConsentStepTitle: 'Ouderlijke toestemming',
    pf_verifyEmailDesc: 'Voer de code in die naar uw e-mail is gestuurd om de registratie te voltooien',
    pf_consentDesc: 'Bekijk en geef toestemming voor gegevensverwerking',
    pf_yourName: 'Naam deelnemer *',
    pf_yourNamePlaceholder: 'Voer uw volledige naam in',
    pf_emailAddress: 'E-mailadres *',
    pf_assessmentLanguage: 'Taal van de beoordeling',
    pf_emailPlaceholder: 'Voer uw e-mailadres in',
    pf_invalidEmail: 'Voer een geldig e-mailadres in',
    pf_yourAge: 'Uw leeftijd *',
    pf_selectAge: 'Selecteer uw leeftijd',
    pf_yearsUnit: 'jaar',
    pf_dyslexiaTested: 'Bent u getest op dyslexie? *',
    pf_iAmDyslexic: 'Ja, officieel gediagnosticeerd',
    pf_iAmNotDyslexic: 'Getest en geen dyslexie',
    pf_notKnown: 'Niet bekend',
    pf_parentName: 'Naam ouder *',
    pf_parentNamePlaceholder: 'Voer de naam van de ouder in',
    pf_childName: 'Naam kind *',
    pf_childNamePlaceholder: 'Voer de naam van het kind in',
    pf_childAgeLabel: 'Leeftijd kind *',
    pf_selectChildAge: 'Selecteer leeftijd kind',
    pf_childDyslexiaTested: 'Is uw kind getest op dyslexie? *',
    pf_yesHasDyslexia: 'Ja, officieel gediagnosticeerd',
    pf_yesNoDyslexia: 'Getest en geen dyslexie',
    pf_noNotTested: 'Nee, nog nooit getest',
    pf_nativeLangQuestion: 'Welke taal spreek je thuis?',
    pf_browserLangDetected: 'Browsertaal gedetecteerd:',
    pf_availableInSystem: '✓ Beschikbaar in ons systeem',
    pf_yesNative: 'Ja',
    pf_othersNative: 'Anderen',
    pf_specifyNative: 'Geef uw moedertaal op *',
    pf_selectNativePlaceholder: 'Selecteer uw moedertaal',
    pf_selectNativeError: 'Selecteer uw moedertaal',
    pf_nativeLangNote: 'Dit helpt ons nauwkeurigere beoordelingsresultaten te geven op basis van uw taalachtergrond. Uw browsertaal ({lang}) werd automatisch gedetecteerd — we gebruiken nooit uw IP-adres voor taaldetectie.',
    pf_forYourChild: 'Voor uw kind',
    pf_childExplanation: 'De computer kijkt hoe je leest — je gezicht, ogen en typen — om je leesstijl te begrijpen. Er gebeurt niets slechts met je gegevens. Je ouder heeft gezegd dat het goed is, en je kunt stoppen wanneer je wilt.',
    pf_parentalConsentLabel: 'Ouderlijke toestemming *',
    pf_parentalConsentText: 'Ik geef toestemming voor de verwerking van de gezichts-, oogbewegings- en toetsenbordinteractiegegevens van mijn kind (of van mezelf) voor dyslexiescreening en leeronderzoek in overeenstemming met de AVG en de MDR.',
    pf_dataConsentLabel: 'Toestemming gegevensverwerking en privacybeleid *',
    pf_dataConsentText: 'Ik ga akkoord met de verwerking van mijn persoonsgegevens voor screeningsdoeleinden.\nIk heb het privacybeleid en de servicevoorwaarden gelezen en ga hiermee akkoord.',
    pf_consentPre: 'Ik ga akkoord met het',
    pf_consentPrivacyLink: 'Privacybeleid',
    pf_consentBetween: 'en de',
    pf_consentTermsLink: 'Servicevoorwaarden',
    pf_consentPost: ', inclusief gegevensverwerking voor screeningsdoeleinden.',
    pf_emailFailedTitle: 'E-mail verzenden mislukt',
    pf_checkYourEmail: 'Controleer uw e-mail',
    pf_emailSentDesc: 'We hebben een 6-cijferige verificatiecode gestuurd naar {email}. Controleer uw inbox en voer de code hieronder in.',
    pf_emailFailedDesc: 'Verzenden naar {email} mislukt.',
    pf_tryAgain: 'Opnieuw proberen',
    pf_sendingEmail: 'Verzenden...',
    pf_verificationCodeLabel: 'Verificatiecode *',
    pf_enterCodePlaceholder: 'VOER 6-CIJFERIGE CODE IN',
    pf_codeExpiry: 'Voer de 6-cijferige code uit uw e-mail in. De code verloopt over 15 minuten.',
    pf_resendCode: 'Code niet ontvangen? Klik om opnieuw te verzenden',
    pf_sendingNewCode: 'Nieuwe code verzenden...',
    pf_continue: 'Doorgaan',
    pf_continueToConsent: 'Doorgaan naar toestemming',
    pf_verifyEmailBtn: 'E-mail verifiëren',
    pf_verifying: 'Verifiëren...',
    pf_processing: 'Verwerken...',
    pf_importantNotice: 'Belangrijke mededeling',
    pf_disclaimer: 'DysTest is een digitaal screeningsinstrument dat is ontworpen om vroege detectie en leerinzichten te ondersteunen. Het biedt geen medische diagnose. Voor een officiële diagnose of klinisch advies, raadpleeg gekwalificeerde zorgprofessionals.',
            cg_readingAssessment: 'Leestoets',
    cg_whatsNext: 'Dit komt er als volgende',
    cg_twoSections: 'Twee korte onderdelen — lees een verhaal, beantwoord dan een paar vragen',
    cg_readStory: 'Lees het verhaal',
    cg_readStoryDesc: 'Neem de tijd — lees op je eigen tempo',
    cg_answerQuestions: 'Beantwoord een paar vragen',
    cg_answerQuestionsDesc: 'Schrijf je antwoorden in je eigen woorden — geen goed of fout',
    cg_exampleQuestion: 'Wat gebeurde er aan het begin van het verhaal?',
    cg_exampleAnswer: 'De jongen liep naar het park…',
    cg_startReading: 'Begin met lezen',
    cg_warmupGame: 'Opwarmspel',
    cg_matchHeading: 'Koppel het woord aan de afbeelding',
    cg_matchSubtitle: 'Klik op een woordkaart en dan op de bijbehorende afbeelding om het paar te voltooien',
    cg_startMatching: 'Starten!',
    cg_demoWord: 'kat',
    cg_allMatched: 'Alle paren gevonden!',
    cg_heatmapContinuing: 'Uw blik-heatmap wordt hieronder weergegeven — gaat zo verder…',
    cg_lookAtTarget: '👁️ Kijkt naar doel!',
    cg_lookAtDot: 'Kijk naar de rode stip',
    cg_sRemaining: 's resterend',
    cg_skipFixation: 'Fixatie overslaan',
    cg_correct: '✓ Correct!',
    cg_tryAgain: '✗ Probeer opnieuw',
    cg_liveMetrics: 'Live statistieken',
    cg_blinks: 'Knipperingen',
    cg_matched: 'Gevonden',
    cg_errors: 'Fouten',
    fpc_instruction: 'Kijk naar elk punt',
    fpc_dotsTotal: 'punten totaal — kijk rechtstreeks naar elk punt en houd je blik vast. Het legt automatisch vast.',
    fpc_cancelCalibration: 'Kalibratie annuleren',
    fpc_clickMe: 'Klik op mij!',
    fpc_eyeTrackingStarting: 'Oogtracking start — u kunt al klikken!',
    fpc_calibrationComplete: 'Kalibratie voltooid!',
    fpc_trainingSamples: '{n} trainingsmonsters opgenomen',
    fpc_allPointsDone: 'Alle punten klaar!',
    fpc_pointOf: 'Punt {current} van {total}',
    fpc_training: 'Training',
    fpc_inactive: 'Calibration inactive',
    fpc_savingCalibration: 'Kalibratie opslaan…',
    fpc_moveEyes: 'Beweeg je ogen naar het punt…',
    fpc_noFace: '⚠️ Geen gezicht gedetecteerd — centreer je gezicht voor de camera',
    fpc_missingIrisTitle: '⚠️ Irisgegevens ontbraken bij te veel punten',
    fpc_missingIrisBody: 'Verschillende kalibratiepunten zijn overgeslagen omdat er geen irislandmarks zijn gedetecteerd.',
    fpc_lowAccuracyTitle: 'Nauwkeurigheid lager dan verwacht',
    fpc_lowAccuracyBody: 'De kalibratiefout is hoger dan ideaal. Dit kan de nauwkeurigheid van de oogtracking verminderen.',
    fpc_redoCalibration: 'Kalibratie herhalen',
    fpc_continueAnyway: 'Toch doorgaan',
    fpc_lookAtDot: 'Kijk rechtstreeks naar het punt',
    fpc_dotReady: '✓ Punt vastgelegd — ga verder…',
    fpc_keepLooking: 'Blijf naar het punt kijken — het legt automatisch vast',
    fpc_captured: '✓ Vastgelegd! Naar het volgende…',
    fpc_checkingAccuracy: 'Nauwkeurigheid controleren',
    fpc_valGotIt: 'Gelukt! Naar het volgende…',
    fpc_valHoldStill: 'Stil blijven — gegevens worden verzameld…',
    fpc_valLookDot: 'Kijk naar het punt — het wordt oranje als het klaar is',
    fpc_valCheck: 'CHECK',

    acp_welcome: 'Welkom, {name}!',
    acp_setupSubtitle: 'Laten we uw beoordeling instellen',
    acp_setupVerification: 'Installatieverificatie',
    acp_setupStepsDesc: 'Voltooi alle stappen om de beoordeling te ontgrendelen',
    acp_step1Title: 'Camera actief',
    acp_step1Desc: 'Camera start automatisch — geen actie vereist',
    acp_step2Title: 'Cameraverificatie',
    acp_step2Desc: 'Controleer camerakwaliteit en stabiliteit',
    acp_step3Title: 'Typtest',
    acp_step3Desc: 'Controleer toetsenbordfunctionaliteit',
    acp_step4Title: 'Oogkalibratie',
    acp_step4Desc: 'Kalibreer het oogvolgingssysteem',
    acp_eyeTrackingActive: '✓ Oogvolging actief',
    acp_eyeTrackingError: '⚠ Oogvolgingsfout:',
    acp_startingEyeTracking: '⏳ Oogvolging starten...',
    acp_cameraReady: '👁 Camera gereed',
    acp_waitingForCamera: '📷 Camera start automatisch...',
    acp_stepDone: 'Klaar',
    acp_stepInProgress: 'Bezig',
    acp_checkingCameraStability: 'Camerastabiliteit controleren...',
    acp_cameraVerified: 'Camera geverifieerd ✓',
    acp_autoVerifyingCamera: 'Camera automatisch verifiëren...',
    acp_waitingFaceDetection: 'Wachten op gezichtsdetectie...',
    acp_eyeTrackingStarting: 'Oogvolging starten...',
    acp_calibrationInProgress: 'Kalibratie bezig...',
    acp_eyeTrackingReady: 'Oogvolging gereed ✓',
    acp_startingCalibration: 'Kalibratie starten...',
    acp_distanceHint: 'Houd je gezicht in het midden en stil, op maximaal 60 cm van het scherm',
    acp_distanceLabel: 'max. 60 cm',
    acp_fpsTitle: 'Je camera is wat traag',
    acp_fpsBody: 'Hij levert {fps} beelden per seconde; voor oogmetingen zijn er minstens 10 nodig. Dit helpt meestal binnen een paar seconden:',
    acp_fpsVeryLow: 'Bij deze snelheid zijn sommige oogmetingen misschien niet bruikbaar; de andere taken tellen gewoon mee.',
    acp_fpsTipLight: 'Doe meer licht aan of ga met je gezicht naar een raam',
    acp_fpsTipCharger: 'Sluit de oplader aan (batterijbesparing maakt de laptop trager)',
    acp_fpsTipApps: 'Sluit videogesprekken en andere zware programma\'s',
    acp_fpsCheckAgain: 'Opnieuw controleren',
    acp_fpsChecking: 'Bezig met controleren…',
    acp_fpsContinue: 'Toch doorgaan',
    acp_preparingEyeTracking: 'Oogvolging voorbereiden...',
    acp_cameraPreview: 'Cameravoorvertoning',
    acp_noFaceDetected: 'Geen gezicht gedetecteerd',
    acp_live: 'LIVE',
    acp_cameraVerifiedTitle: 'Camera geverifieerd ✓',
    acp_cameraReadyTitle: 'Camera gereed',
    acp_qualityCheckPassed: 'Kwaliteitscontrole geslaagd',
    acp_optimizedForAssessment: 'Geoptimaliseerd voor beoordeling',
    acp_verifiedBadge: 'Geverifieerd',
    acp_readyBadge: 'Gereed',
    acp_assessmentMetrics: 'Beoordelingsstatistieken',
    acp_faceDistance: 'Gezichtsafstand',
    acp_goodDistance: 'Goede afstand voor beoordeling',
    acp_searching: 'Zoeken...',
    acp_lightLevel: 'Lichtniveau',
    acp_fps: 'FPS',
    acp_fpsExcellent: 'Uitstekende framerate',
    acp_fpsGood: 'Goede framerate',
    acp_fpsModerate: 'Matige framerate',
    acp_fpsLow: 'Lage framerate',
    acp_fpsInitializing: 'Initialiseren...',
    acp_faceDetection: 'Gezichtsdetectie',
    acp_faceDetected: '✓ Gedetecteerd',
    acp_faceDetectedSub: 'Gezicht succesvol gedetecteerd',
    acp_cameraQualityPassed: 'Camerakwaliteitscontrole geslaagd. Klaar voor de volgende stap.',
    acp_visionWarnings: 'Visuele waarschuwingen',
    acp_trackingMetrics: 'Volgstatistieken',
    acp_headPitch: 'Hoofd kantelhoek:',
    acp_headYaw: 'Hoofd draaihoek:',
    acp_headRoll: 'Hoofd rolhoek:',
    acp_gazePoint: 'Blikpunt:',
    acp_emotion: 'Emotie:',
    acp_confidence: 'Betrouwbaarheid:',
    acp_trackingId: 'Tracking-ID:',
    acp_faceId: 'Gezicht-ID:',
    acp_browser: 'Browser:',
    acp_os: 'OS:',
    acp_camera: 'Camera:',
    acp_resolution: 'Resolutie:',
    acp_initializingTracking: 'Volgstatistieken initialiseren...',
    acp_dataQuality: 'Gegevenskwaliteit',
    acp_dataQualityExcellent: 'UITSTEKEND',
    acp_dataQualityGood: 'GOED',
    acp_dataQualityFair: 'MATIG',
    acp_dataQualityDetecting: 'DETECTEREN...',
    acp_dataQualityExcellentDesc: 'Optimaal voor beoordeling',
    acp_dataQualityGoodDesc: 'Goed voor beoordeling',
    acp_dataQualityFairDesc: 'Acceptabele kwaliteit',
    acp_dataQualityDetectingDesc: 'Condities analyseren',
    acp_faceMeshPoints: 'Gezichtsnetpunten',
    acp_completeFaceMesh: 'Volledig gezichtsnet',
    acp_detecting: 'Detecteren...',
    acp_typingTest: 'Typtest',
    acp_typeQwerty: 'Typ {target} om toetsenbord te verifiëren',
    acp_verifyKeyboard: 'Controleer toetsenbordfunctionaliteit',
    acp_activeStatus: 'Actief',
    acp_lockedStatus: 'Vergrendeld',
    acp_typeHere: 'Typ hier...',
    acp_typingCompleted: '✓ Voltooid! Doorgaan naar volgende stap...',
    acp_keepTyping: 'Blijf typen:',
    acp_remaining: 'over',
    acp_startTyping: 'Begin met het typen van de letters hierboven',
    acp_completeCameraVerification: 'Voltooi cameraverificatie om te ontgrendelen',
    acp_lightingPerfect: 'Perfecte verlichting voor beoordeling',
    acp_lightingSlightlyBright: 'Iets te helder — verlaag indien mogelijk',
    acp_lightingTooBright: 'Te helder — verminder verlichting/schermhelderheid',
    acp_lightingSlightlyDim: 'Iets te donker — verhoog indien mogelijk',
    acp_lightingTooDim: 'Te donker — verhoog de verlichting',
    acp_positionFace: '👤 Positioneer uw gezicht in de cameraweergave',
    acp_faceDetectedStarting: '✅ Gezicht gedetecteerd — verificatie starten...',
    acp_adjustDistance: 'Pas uw afstand tot de camera aan',
    acp_moveFarther: 'Ga verder van de camera af',
    acp_distanceInRange: 'Afstand ziet goed uit',
    pdg_moveCloser: 'Kom dichter bij de camera',
    pdg_moveFarther: 'Ga verder van de camera af',
    pdg_dismiss: 'Negeren',
    acp_noData: 'Geen gegevens',
    acp_setupProgress: 'Installatievoortgang',
    acp_stepsComplete: '{n} van 4 stappen voltooid',
    acp_environment: 'Omgeving',
    acp_checkingEllipsis: 'Controleren…',
    acp_waitingEllipsis: 'Wachten…',
    acp_analysingConditions: 'Cameracondities analyseren…',
    acp_positionFaceCamera: 'Positioneer uw gezicht voor de camera',
    acp_faceAligned: 'Gezicht uitgelijnd',
    shared_stepOf: 'Stap {step} van {total}',
    shared_start: 'start',
    cal_introHeading: 'KALIBRATIE',
    cal_introSubtitle: 'Volg de stippen en houd je hoofd stil',
    story_introHeading: 'LEZEN EN VRAGEN',
    fpc_lookHere: 'Hier kijken!',
            pfp_chip_gdpr: 'AVG-conform',
    pfp_chip_mdr: 'MDR-conform',
    pfp_chip_noData: 'Geen gegevensdeling',
    pfp_chip_languages: '8 Talen',
    kbv_header: 'Toetsenbord dynamiek',
    kbv_interKey: 'Interval tussen toetsen',
    kbv_typingSpeed: 'Typsnelheid',
        pfp_aiBadge: 'Eye-tracking dyslexie screening',
    pfp_whyBadge: 'Waarom DysTest',
    mat_missionBadge: 'Onze missie & technologie',
    mat_eyeBadge: 'Oogbewegingen',
    mat_kbdBadge: 'Toetsaanslaganalyse',
    mat_ferBadge: 'Gezichtsuitdrukking',
    pfp_noBrowserFooter: 'Geen account nodig · Volledig in de browser · Resultaten in <15 minuten',
    eye_viz_landmarks: '478 Punten',
    eye_viz_irisFaceMesh: 'Iris + Gezichtsmesh',
    eye_viz_fps: '30 FPS realtime',
    eye_viz_validation: '9-Punt + 4-Punt Validatie',
    eye_viz_calibration: 'Klinische 13-punts kalibratie',
    ran_anim_rapidNaming: 'Snel benoemen',
    ran_anim_predictor: '#1 dyslexie-indicator',
    ran_anim_ageNormed: 'Leeftijdsnorm scoring',
    ran_anim_zscore: 'z-score + percentiel',
    acp_hideDetails: 'Details verbergen ▲',
    acp_showDetails: 'Details tonen ▼',
    acp_moveCloser: 'kom dichterbij',
    acp_headLabel: 'Hoofd',
    acp_setupTipsTitle: 'Snelle installatietips',
    acp_tip1: 'Zit ~50 cm van uw scherm',
    acp_tip2: 'Zorg voor gelijkmatige, heldere verlichting op uw gezicht',
    acp_tip3: 'Houd uw hoofd recht en kijk direct in de camera',
    acp_tip4: 'Gebruik een rustige ruimte voor een ongestoorde beoordeling',
    acp_progressLabel: 'Voortgang',

    priv_gdprTitle: 'AVG-conform',
    priv_gdpr1: 'Verifieerbare ouderlijke toestemming voor gebruikers onder de 13',
    priv_gdpr2: 'Dataminimalisatie en doelbinding',
    priv_gdpr3: 'Recht op inzage, rectificatie en verwijdering van gegevens',
    priv_gdpr4: 'Transparante gegevensverwerking',
    priv_mdrTitle: 'MDR-afgestemd',
    priv_mdr1: 'Extra bescherming voor kwetsbare personen',
    priv_mdr2: 'Klinische veiligheid en prestaties',
    priv_mdr3: 'Duidelijk onderscheid tussen screening en diagnose',
    priv_mdr4: 'Ethisch omgaan met gezondheidsgegevens',
    priv_retentionTitle: 'Beleid voor gegevensbewaring',
    priv_12months: '12 maanden',
    priv_12monthsDesc: 'Eye-tracking coördinaten & toetsaanslagen',
    priv_24months: '24 maanden',
    priv_24monthsDesc: 'Analysemetadata',
    priv_parentsControl: 'Oudercontrole',
    priv_deleteAnytime: 'Op elk moment verwijderen',

    mat_headline1: 'MENSELIJK EMPATHIE.',
    mat_headline2: 'KUNSTMATIGE PRECISIE',
    mat_subheadline: 'Persoonlijke ervaring en geavanceerde AI combineren om dyslexiescreening',
    mat_subheadlineHighlight: 'toegankelijk voor iedereen te maken',
    mat_whatTitle: 'WAT WE DOEN',
    mat_what1: 'We combineren diepgaande expertise in dyslectische leespatronen met geavanceerde AI-technologie. Na jaren onderzoek hebben we deze inzichten bijgebracht aan een adaptieve AI.',
    mat_what2: 'Onze AI voert intelligente, meerlaagse tests uit — elke reactie vergeleken met duizenden echte leespatronen. Ze leert in realtime en stelt de juiste vervolgvragen.',
    mat_what3: 'Alles om gezinnen de duidelijkheid te geven die ze nodig hebben om de volgende stap met vertrouwen te zetten.',
    mat_whyTitle: 'WAAROM WE DIT DOEN',
    mat_why1: 'Stel u voor dat uw kind dezelfde leesproblemen heeft als u vroeger — maar nu kent u de naam: dyslexie. U wilt antwoorden, maar de eerste test kost €750 tot €1.800 — voor veel gezinnen onbereikbaar.',
    mat_why2: 'Die realiteit breekt ons hart. Elk kind verdient te begrijpen hoe het leert. Elke ouder verdient antwoorden.',
    mat_why3: 'Daarom zijn wij er — want begrip van je eigen geest mag nooit een privilege zijn. Het is een mensenrecht.',
    mat_bgTitle: 'ONZE ACHTERGROND',
    mat_bg1: 'Wij hebben zelf met dyslexie geleefd en meer dan 20 jaar gespecialiseerd in toegankelijk lezen. Door deze ervaring te combineren met AI hebben we een eenvoudig, betaalbaar en levensveranderend dyslexie-screeningsinstrument ontwikkeld.',
    mat_bg2: 'Onze AI meet niet alleen leessnelheid of telt fouten — zij begrijpt het hoe achter elke oogbeweging, pauze en herstel. Ze kijkt naar de cognitieve processen die lezen zo uitdagend maken.',
    mat_techTitle: 'ONZE TECHNOLOGIE',
    mat_tech1: 'Door deze subtiele verschillen te versterken, leert ons systeem dyslexie te onderscheiden van andere leesproblemen met buitengewone precisie. We gebruiken deep clustering — een geavanceerde vorm van unsupervised learning.',
    mat_tech2: 'Deze meerlaagse, kruisreferentie-aanpak biedt meer zekerheid dan enige eerdere methode — dieper en verder dan ooit tevoren.',
    mat_eyeTitle: 'Oogvolging',
    mat_eyeText: 'We meten blikstabiliteit, fixatieduur en saccadische bewegingen om te ontdekken hoe de visuele focus verschuift tijdens het lezen.',
    mat_kbdTitle: 'Toetsenbordynamica',
    mat_kbdText: 'Toetsaanslagritme, aarzeling en correctiesnelheid onthullen sequentie- en fonologische uitdagingen die uniek zijn voor dyslectische profielen.',
    mat_ferTitle: 'Gezichtsemoties herkenning (FER)',
    mat_ferText: 'Subtiele uitdrukkingen onthullen frustratie, betrokkenheid of opluchting — en helpen onze AI de emotionele laag achter de leesinspanning te begrijpen.',

    footer_about: 'Over ons',
    footer_blog: 'Publications',
    footer_contact: 'Contact',
    footer_faq: 'FAQ',
    footer_privacy: 'Privacy',
    footer_terms: 'Gebruiksvoorwaarden',
    footer_tagline: 'AI-gestuurde dyslexie screening met realtime iris tracking, toetsenbord dynamica en gezichtsuitdrukking analyse — beschikbaar in 8 talen, volledig in de browser.',
    footer_productHeading: 'Product',
    footer_legalHeading: 'Juridisch',
    footer_mission: 'Gebouwd om dyslexie screening toegankelijk te maken voor iedereen, in elke taal.',
    footer_copyright: 'Alle rechten voorbehouden',
    footer_madeWith: 'Gemaakt met doel voor dyslexie bewustwording',
    footer_allSystems: 'Alle systemen operationeel',

    fp_assessmentBadge: 'Laatste stap',
    fp_feedbackTitle: 'Deel nog één opmerking',
    fp_feedbackDesc: 'Optionele feedback helpt ons de beoordelingservaring te verbeteren.',
    fp_shareThoughts: 'Deel uw gedachten',
    fp_optional: 'Optioneel',
    fp_words: 'Woorden',
    fp_corrections: 'Correcties',
    fp_speed: 'Snelheid',
    fp_feedbackPlaceholder: 'Was iets moeilijk, onduidelijk of voor verbetering vatbaar?',
    fp_observationNotesTitle: 'Observatienotities (optioneel)',
    fp_observationNotesDesc: 'Voor de ouder of toezichthouder die aanwezig was tijdens de test: alles wat u opmerkte dat het scherm niet kan zien — afleiding, vermoeidheid, huilen, geluid, of iets anders dat het waard is om samen met de resultaten te noteren.',
    fp_observationNotesPlaceholder: 'bijv. "Leek moe tijdens de woordschrijftest" of "Werd afgeleid door een broer of zus tijdens Verhaal 1"',
    fp_generatingReport: 'Uw rapport wordt gegenereerd…',
    fp_submitBtn: 'Afronden en rapport bekijken',
    fp_skipHint: 'Feedback is optioneel. Ga verder wanneer u klaar bent.',
    fp_youNailedIt: 'Beoordeling voltooid',
    fp_reportGenerated: 'Uw rapport staat klaar in uw dashboard.',
    fp_copySentTo: 'Toegangsgegevens verzonden naar',
    fp_welcomeBack: 'Rapport opgeslagen',
    fp_newReportAdded: 'Toegevoegd aan uw dashboardresultaten.',
    fp_reportReady: 'Uw rapport is klaar',
    fp_reportSubtitle: 'Volledige analyse, oogbewegingsplayback & dyslexie-indicatoren',
    fp_openingReport: 'Uw rapport openen…',
    fp_viewMyReport: 'Mijn rapport bekijken',
    fp_signInLater: 'of meld u later aan bij',
    fp_saveForAccess: 'Bewaar voor toekomstige toegang',
    fp_emailLabel: 'E-mail',
    fp_passwordLabel: 'Wachtwoord',
    fp_copied: 'Gekopieerd',
    fp_copy: 'Kopiëren',
    fp_pwUpdated: 'Wachtwoord succesvol bijgewerkt',
    fp_setCustomPw: 'Stel een eigen wachtwoord in',
    fp_newPwPlaceholder: 'Nieuw wachtwoord (min. 4 tekens)',
    fp_save: 'Opslaan',
    fp_cancel: 'Annuleren',
    fp_signInLink: 'Dashboard openen →',
    fp2_saving: 'Je resultaten worden opgeslagen…',
    fp2_savingSub: 'Dit duurt een paar seconden. Houd deze pagina open.',
    fp2_allDone: 'Klaar',
    fp2_reportReadySent: 'Het rapport staat klaar. We hebben de inloggegevens gestuurd naar',
    fp2_reportReadyReturning: 'Het rapport staat klaar en is toegevoegd aan je dashboard.',
    fp2_passwordLine: 'Je wachtwoord (staat ook in de e-mail):',
    fp2_openReport: 'Open het rapport',
    fp2_saveFailed: 'Je resultaten konden nog niet worden opgeslagen.',
    fp2_saveFailedSub: 'Controleer de internetverbinding en probeer het opnieuw. Houd deze pagina open.',
    fp2_tryAgain: 'Opnieuw proberen',
    fp2_sessionTitle: 'Is er iets over de test dat we moeten weten?',
    fp2_sessionOptional: 'Optioneel · verandert de uitslag niet',
    fp2_cTired: 'Moe of afgeleid',
    fp2_cCameraMic: 'Probleem met camera of microfoon',
    fp2_cNoisy: 'Lawaai of onderbrekingen',
    fp2_cLanguage: 'Niet de eerste taal',
    fp2_cHelped: 'Iemand hielp met antwoorden',
    fp2_cFroze: 'Pagina liep vast of moest herladen',
    fp2_saveNotes: 'Notities opslaan',
    fp2_notesSaved: 'Notities opgeslagen',
    fp2_notesFailed: 'De notities konden niet worden opgeslagen. Probeer het opnieuw.',
    fp_parentNote: '👨‍👩‍👧 Een bericht voor de ouder',
    fp_parentNoteDesc: 'De beoordeling is afgerond. Deel eventueel uw observaties over hoe uw kind de taken vandaag heeft aangepakt (optioneel).',
    fp_screeningResult: 'Screeningsresultaat',
    fp_riskTypical: 'Typisch — geen significante indicatoren',
    fp_riskBorderline: 'Grensgeval — enkele indicatoren aanwezig',
    fp_riskHighRisk: 'Hoog risico — meerdere indicatoren gedetecteerd',
    fp_riskVeryHighRisk: 'Zeer hoog risico — sterke indicatoren in meerdere domeinen',
    fp_confidence: 'Betrouwbaarheid',
    fp_keyFindings: 'Belangrijkste bevindingen',
    fp_disclaimer: 'Dit is alleen een screeningtool — geen klinische diagnose. Raadpleeg een geregistreerde onderwijspsycholoog voor een volledig assessment.',
    fp_notAssessed: 'Niet beoordeeld',
    fp_percentile: 'e percentiel',
    fp_domainTypical: '✓ Typisch',
    fp_domainBorderline: '⚠ Grensgeval',
    fp_domainHighRisk: '✗ Hoog risico',
    fp_aiReportTitle: 'AI Gepersonaliseerd Rapport',
    fp_aiGenerating: 'DysTest AI genereert uw gepersonaliseerde rapport…',
    fp_aiGenerated: 'Gegenereerd door DysTest AI · Geen klinische diagnose',
    fp_aiAnalysing: 'Beoordelingsgegevens analyseren…',
    fp_strengths: 'Sterktes',
    fp_areasToSupport: 'Aandachtspunten',
    fp_noDifficulties: 'Geen significante moeilijkheden gedetecteerd.',
    fp_eyeTracking: 'Oogtracking:',
    fp_recommendations: 'Aanbevelingen',
    fp_nextStep: 'Volgende stap:',
    pp_title: 'Privacybeleid',
    pp_bannerTitle: 'Uw Privacy is Heilig',
    pp_bannerDesc: 'Wij geloven dat uw persoonlijke gegevens van u zijn, niet van ons om te verkopen. We verzamelen alleen wat nodig is voor nauwkeurige dyslexiescreening, en beschermen het met toonaangevende beveiliging. U heeft altijd volledige controle over uw informatie.',
    pp_contactTitle: 'Vragen Over Uw Privacy?',
    pp_contactDesc: 'We staan voor transparantie. Als u vragen heeft over hoe we uw gegevens verwerken, helpen we u graag.',
    pp_privacyInquiries: 'Privacy-vragen',
    pp_generalSupport: 'Algemene Ondersteuning',
    pp_acknowledgment: 'Door gebruik te maken van de DysTest-service erkent u dat u dit Privacybeleid heeft gelezen en begrepen.',
    tos_title: 'Servicevoorwaarden',
    tos_missionTitle: 'Onze Missie',
    tos_missionDesc: 'Uw eigen geest begrijpen mag geen luxe zijn — het is een mensenrecht. Onze missie is om dyslexiescreening toegankelijk, betaalbaar en nauwkeurig te maken voor elk gezin dat het nodig heeft.',
    tos_contactTitle: 'Vragen Over Deze Voorwaarden?',
    tos_contactDesc: 'We helpen u graag. Als u vragen heeft over onze Servicevoorwaarden, neem dan gerust contact met ons op.',
    tos_acknowledgment: 'Door gebruik te maken van de DysTest-service erkent u dat u deze Servicevoorwaarden heeft gelezen, begrepen en ermee akkoord gaat.',
    shared_quickNav: 'Snelle Navigatie',
    shared_backHome: '← Terug naar Start',
    shared_effectiveDate: 'Ingangsdatum: 30 oktober 2025',
    shared_lastUpdated: 'Laatste update: 30 oktober 2025',
    shared_footerTagline: 'Dyslexietesten nauwkeurig, toegankelijk en betaalbaar maken.',
    shared_website: 'Website',
    shared_email: 'E-mail',
    blog_knowledgeBadge: 'DysTest Kenniscentrum',
    blog_title: 'DysTest Blog',
    blog_subtitle: 'Expertinzichten over dyslexie, leermoeilijkheden en hoe AI vroege detectie en ondersteuning revolutioneert',
    blog_searchPlaceholder: 'Zoek artikelen over dyslexie, leermoeilijkheden, AI-beoordeling...',
    blog_catAll: 'Alle',
    blog_catUnderstanding: 'Dyslexie begrijpen',
    blog_catEarlyDetection: 'Vroege detectie',
    blog_catTechnology: 'Technologie',
    blog_catNews: 'Nieuws',
    blog_featuredBadge: '⭐ Uitgelicht',
    blog_featuredArticles: 'Uitgelichte artikelen',
    blog_allArticles: 'Alle artikelen',
    blog_article: 'artikel',
    blog_articles: 'artikelen',
    blog_readMore: 'Lees meer →',
    blog_found: 'Gevonden',
    blog_forQuery: 'voor',
    blog_noResults: 'Geen artikelen gevonden',
    blog_noResultsDesc: 'Pas uw zoekopdracht of filtercriteria aan',
    blog_clearFilters: 'Filters wissen en alle artikelen tonen',
    blog_newsletterTitle: 'Blijf op de hoogte van dyslexieonderzoek',
    blog_newsletterDesc: 'Ontvang de nieuwste inzichten over dyslexieonderzoek, AI-technologie en leerstrategieën in uw inbox.',
    blog_newsletterBtn: 'Abonneer op updates',
    blog_newsletterPrivacy: 'Geen spam. Afmelden op elk moment. Wij respecteren uw privacy.',
    blog_newsletterEmailPlaceholder: 'Voer uw e-mailadres in',
    blog_newsletterSending: 'Bezig met versturen…',
    blog_newsletterCheckInbox: 'Bijna klaar — kijk in je inbox en klik op de link om te bevestigen.',
    blog_newsletterError: 'Er ging iets mis. Probeer het later opnieuw.',
    nws_working: 'Een moment…',
    nws_confirmedTitle: 'Je bent aangemeld',
    nws_confirmedBody: 'Dank je! Je ontvangt nieuwe blogs, technische papers en onze nieuwsbrief. In elke e-mail staat een afmeldlink.',
    nws_wasUnsubscribed: 'Dit adres is afgemeld. Meld je opnieuw aan via de blog om updates te ontvangen.',
    nws_unsubTitle: 'Afmelden voor updates van DysTest?',
    nws_unsubBody: 'Je ontvangt dan geen nieuwe blogs, technische papers of nieuwsbrieven meer.',
    nws_unsubBtn: 'Afmelden',
    nws_unsubDoneTitle: 'Je bent afgemeld',
    nws_unsubDoneBody: 'Je ontvangt geen updates meer. Toch van gedachten veranderd? Je kunt je opnieuw aanmelden via de blog.',
    nws_invalidTitle: 'Deze link is niet geldig',
    nws_invalidBody: 'De link is misschien oud of onvolledig. Je kunt je opnieuw aanmelden via de blog.',
    nws_toBlog: 'Naar de blog',
    blog_backToArticles: 'Terug naar artikelen',
    blog_loadingArticle: 'Artikel laden...',
    blog_articleNotFound: 'Artikel niet gevonden',
    blog_ctaTitle: 'Meer weten?',
    blog_ctaDesc: 'Ontdek hoe DysTest leermoeilijkheden kan identificeren en het potentieel van elk kind kan ontgrendelen met onze AI-beoordeling.',
    blog_tryDystest: 'Probeer DysTest-beoordeling',
    blog_readMoreArticles: 'Meer artikelen lezen',
    faq_badge: 'Vragen? Wij hebben de antwoorden',
    faq_title: 'Veelgestelde vragen',
    faq_subtitle: 'Alles wat u moet weten over onze',
    faq_subtitleHighlight: 'Eye-tracking dyslexiescreening',
    faq_searchPlaceholder: "Zoek vragen... (bijv. 'kosten', 'privacy', 'hoe lang')",
    faq_mostPopular: 'Meest gestelde vragen',
    faq_noResults: 'Geen vragen gevonden die overeenkomen met uw zoekopdracht.',
    faq_clearFilters: 'Filters wissen',
    faq_stillHave: 'Heeft u nog vragen?',
    faq_supportDesc: 'Ons ondersteuningsteam staat klaar om u te helpen. Wij reageren doorgaans binnen 24 uur.',
    faq_contactSupport: 'Contact opnemen',
    faq_startScreening: 'Screening starten',
    faq_catAll: 'Alle',
    faq_related: 'Gerelateerd:',
    about_badge: 'Ons Verhaal',
    about_title: 'Over DysTest',
    about_subtitle: 'Wij geloven dat elk kind het verdient begrepen te worden — niet alleen getest.',
    about_backHome: '← Terug naar Start',
    about_ctaTitle: 'Klaar om te beginnen?',
    about_ctaDesc: 'Start vandaag nog een meelevende screening voor uw kind en ontdek hoe DysTest het potentieel van elke leerling ontsluit.',
    about_startScreening: 'Screening starten',
    about_startAssessment: 'Nu starten',
    about_navWhy: 'Waarom DysTest Bestaat',
    about_navMissionValues: 'Missie & Waarden',
    about_navTechnology: 'Technologie',
    about_navTeam: 'De Mensen Achter DysTest',
    ran_audio_preLetter: 'Letters benoemen. Lees elke rij letters hardop zo snel als je kunt.',
    ran_audio_preDigit: 'Nu cijfers. Lees elke rij getallen hardop zo snel als je kunt.',
    ran_audio_preColor: 'Nu kleuren. Zeg de kleur van elk vakje hardop zo snel als je kunt.',
    ran_audio_preObject: 'Nu voorwerpen. Benoem elk plaatje hardop zo snel als je kunt.',
    ran_audio_runLetter: 'Lees elke letter hardop zo snel als je kunt.',
    ran_audio_runDigit: 'Lees elk cijfer hardop zo snel als je kunt.',
    ran_audio_runColor: 'Zeg de kleur van elk vakje hardop zo snel als je kunt.',
    ran_audio_runObject: 'Benoem elk plaatje hardop zo snel als je kunt.',
    ran_audio_practice: 'Laten we oefenen. Zeg elke letter hardop.',
    ran_intro_t1_heading: 'Laten we letters zeggen! 🔤',
    ran_intro_t1_desc1: 'Je ziet grote letters op het scherm.',
    ran_intro_t1_desc2: 'Zeg ze allemaal hardop zo snel als je kunt!',
    ran_intro_heading: 'RAN',
    ran_intro_desc1: 'Je ziet rijen letters, cijfers, kleuren en voorwerpen. Lees elke rij zo snel mogelijk hardop — van links naar rechts.',
    ran_intro_desc2: 'De begeleider drukt op Volgende rij als je klaar bent. We oefenen eerst kort.',
    ran_intro_labLetters: 'Letters',
    ran_intro_labDigits: 'Cijfers',
    ran_intro_labColors: 'Kleuren',
    ran_intro_labObjects: 'Voorwerpen',
    ran_practice_t1_heading: 'Kun jij deze zeggen? 👀',
    ran_practice_heading: 'Oefening',
    ran_practice_t1_desc: 'Zeg elke letter hardop. Begin links!',
    ran_practice_desc: 'Lees deze rij letters hardop, van links naar rechts. De begeleider tikt op Volgende rij als je klaar bent.',
    ran_practice_hint: 'Zeg: "a · o · s · p · k" — tik dan op de knop hieronder.',
    ran_btn_try: 'Probeer het! 🎉',
    ran_btn_practise: 'Laten we oefenen',
    ran_btn_skip: 'Overslaan',
    ran_btn_gotIt: 'Begrepen — start letters →',
    ran_btn_begin: 'Begin — lees rij 1 →',
    ran_btn_nextRow: 'Volgende rij',
    ran_btn_continue: 'Doorgaan',
    ran_preLetter_title: 'Letters benoemen  (RAN-L)',
    ran_preLetter_subtitle: '50 letters · 5 rijen van 10. Lees elke rij hardop zo snel als je kunt.',
    ran_preLetter_detail: 'De begeleider tikt op Volgende rij na elke rij.',
    ran_preLetter_btn: 'Toon het rooster →',
    ran_preDigit_title: 'Letters klaar! Nu cijfers  (RAN-D)',
    ran_preDigit_subtitle: 'Dezelfde taak met cijfers: 2 · 4 · 5 · 7 · 8',
    ran_preDigit_detail: '50 cijfers · 5 rijen van 10 · zelfde regels.',
    ran_preDigit_btn: 'Start cijfers →',
    ran_preColor_title: 'Cijfers klaar! Nu kleuren  (RAN-C)',
    ran_preColor_subtitle: 'Zeg de kleur van elk vakje hardop, zo snel als je kunt.',
    ran_preColor_detail: '50 gekleurde vakjes · 5 rijen van 10 · zelfde regels.',
    ran_preColor_btn: 'Start kleuren →',
    ran_preObject_title: 'Kleuren klaar! Nu voorwerpen  (RAN-O)',
    ran_preObject_subtitle: 'Benoem elk plaatje hardop, zo snel als je kunt.',
    ran_preObject_detail: '50 voorwerpen · 5 rijen van 10 · zelfde regels.',
    ran_preObject_btn: 'Start voorwerpen →',
    ran_done_t1_heading: 'Geweldig gedaan! 🌟',
    ran_done_heading: 'Alle benoementaken voltooid!',
    ran_done_t1_desc: 'Je hebt alle letters gezegd!',
    ran_done_desc: 'Hier zijn de resultaten:',
    ran_badge: 'Snelbenoemingstest',
    ran_intro_watchDemo: '👀 Kijk hoe het werkt',
    ran_intro_t1_lead: 'Kijk naar elke letter en zeg hem hardop zo snel als je kunt — van links naar rechts!',
    ran_intro_step1: 'Kijk naar de rij',
    ran_intro_step2: 'Zeg elk item hardop',
    ran_intro_step3: 'Ga zo snel als je kunt!',
    ran_intro_demoLabel: 'Zeg elk item hardop, zo snel als je kunt!',
    ran_btn_start: 'Start 🚀',
    ran_btn_tapStart: 'Klik om rij 1 te starten',
    ran_btn_listening: 'Luisteren…',
    ran_btn_repeat: 'Instructie herhalen',
    ran_processing: 'Verwerken…',
    ran_transcribing: 'Audio transcriberen met Whisper…',
    ran_transcribingDesc: 'Spreeknauwkeurigheid analyseren — dit duurt een paar seconden',
    ran_stat_totalTime: 'Totale tijd',
    ran_stat_itemsPerSec: 'Items/s',
    ran_stat_avgItem: 'Gem. item',
    ran_stat_mistakes: 'Fouten',
    ran_paceHint: 'Gemarkeerd = huidige rij  ·  Beoordelaar bepaalt het tempo',
    ran_running_letter: '🔤 RAN-L — Letters',
    ran_running_digit: '🔢 RAN-D — Cijfers',
    ran_running_color: '🎨 RAN-C — Kleuren',
    ran_running_object: '🦎 RAN-O — Objecten',
    ran_header_letter: 'RAN-L',
    ran_header_digit: 'RAN-D',
    ran_header_color: 'RAN-C',
    ran_header_object: 'RAN-O',

    nav_home: 'Home',
    nav_about: 'Over ons',
    nav_resources: 'Bronnen',
    nav_startAssessment: 'Start beoordeling',
    nav_langMenuTitle: 'Taal van de beoordeling',
    nav_langMenuHint: 'Verhalen en instructies volgen deze taal',
    nav_techPapers: 'Technische Publicaties',
    nav_blog: 'Blog',
    nav_guides: 'Gidsen',
    nav_faq: 'FAQ',

        wwt_badge: 'Woordschrijftest',
    wwt_introTitle: 'Onthoud en typ het woord',
    wwt_introDesc: 'Een woord wordt 5 seconden getoond — daarna wist het zichzelf letter voor letter en typ je het uit je geheugen',
    wwt_demoHint: 'Het woord verdwijnt — je typt het uit je geheugen',
    wwt_startWriting: 'Begin met schrijven!',
    wwt_rememberWord: 'Onthoud dit woord',
    wwt_watchCountdown: 'Kijk naar de aftelling — typ het dan uit je geheugen',
    wwt_typeWord: 'Typ het woord dat je zag',
    wwt_pressEnter: 'Typ het in en druk op Enter of Volgende',
    wwt_nextWord: 'Volgend woord',
    wwt_finish: 'Klaar',
    wwt_done: 'Goed gedaan!',
    wwt_correct: 'woorden correct',
    wwt_continue: 'Doorgaan',
    wwt_wordOf: 'Woord {current} van {total}',
    form_badgeText: 'Stap 1/8: Registreren',
    form_heading: 'Registreer & Begin',
    form_privacyNote: 'Uw gegevens zijn beschermd door de AVG- en MDR-regelgeving. Er wordt geen persoonlijk identificeerbare informatie gedeeld met derden.',

    // ── Microphone check panel (mic_*) ───────────────────────────────────
    mic_title: 'Microfooncontrole',
    mic_sub_checking: 'Microfoon wordt gecontroleerd…',
    mic_sub_ready: 'Microfoon klaar — tik op Testen om op te nemen',
    mic_sub_recording: 'Opname bezig… spreek nu',
    mic_sub_retry: 'We hebben je niet goed gehoord — probeer het opnieuw',
    mic_sub_passed: 'Microfoon werkt perfect!',
    mic_sub_denied: 'Microfoontoegang geweigerd',
    mic_pleaseSpeak: '🗣️ Spreek nu alsjeblieft…',
    mic_retryBody: 'We konden je niet duidelijk horen. Spreek wat luider en probeer het opnieuw.',
    mic_testBtn: 'Microfoon testen',
    mic_tryAgain: 'Opnieuw proberen',
    mic_continueBtn: 'Doorgaan',
    mic_skipDenied: 'Overslaan (geen microfoon)',
    mic_skip: 'Microfooncontrole overslaan',
    ud_myDashboard: 'Mijn dashboard',
    ud_myAssessmentReports: 'Mijn beoordelingsrapporten',
    ud_noAssessmentsFound: 'Geen voltooide beoordelingen gevonden.',
    ud_assessmentsFoundSingular: '1 voltooide beoordeling gevonden.',
    ud_assessmentsFoundPlural: '{n} voltooide beoordelingen gevonden.',
    ud_loadError: 'Kan uw beoordelingen niet laden. Controleer uw verbinding en vernieuw de pagina.',
    ud_serviceUnavailable: 'De server is tijdelijk niet beschikbaar (503). Wacht even en vernieuw de pagina.',
    ud_progressOverTime: 'Voortgang in de tijd',
    ud_longitudinalSubtitle: '{n} beoordelingen · samengestelde z-scoretrend',
    ud_typical: 'Typisch (z ≥ −0,5)',
    ud_borderline: 'Grensgebied (z < −0,5)',
    ud_highRisk: 'Hoog risico (z < −1,0)',
    ud_veryHighRisk: 'Zeer hoog risico (z < −1,5)',
    ud_noAssessmentsFor: 'Geen beoordelingen gevonden voor',
    ud_completeAssessment: 'Voltooi een beoordeling om uw resultaten hier te zien.',
    ud_startAssessment: 'Start een beoordeling',
    ud_assessmentReport: 'Beoordelingsrapport',
    ud_completed: 'Voltooid',
    ud_accuracy: 'NAUWKEURIGHEID',
    ud_blinks: 'KNIPPERINGEN',
    ud_questions: 'VRAGEN',
    ud_rawData: 'Ruwe gegevens (JSON)',
    ud_tabEyeTracking: 'Oogtracking',
    ud_tabRan: 'RAN-analyse',
    ud_tabStory: 'Verhaalsanalyse',
    ud_gazePlaybackTitle: 'Oogtracking afspelen — 3 modi: Raster · Heatmap · Pad',
    ud_noGazeData: 'Geen oogtrackinggegevens beschikbaar voor deze beoordeling.',
    ud_gazeDataNote: 'Oogtrackinggegevens worden vastgelegd tijdens de live beoordelingssessie en opgeslagen met het rapport.',
    ud_ranTitle: 'RAN — Resultaten snelle automatische naamgeving',
    ud_totalTime: 'Totale tijd',
    ud_rawSpeed: 'Ruwe snelheid',
    ud_correctedSpeed: 'Gecorrigeerde snelheid',
    ud_errors: 'Fouten',
    ud_rowTimings: 'Rijtijden',
    ud_transcriptComparison: 'Transcriptvergelijking',
    ud_row: 'Rij',
    ud_audioNote: 'Audioweergave is beschikbaar in het volledige ZIP-rapport · Download volledig rapport (ZIP) hierboven',
    ud_storyTitle: 'Verhaallees-analyse',
    ud_story1Label: 'Verhaal 1 — Leesfase',
    ud_story2Label: 'Verhaal 2 — Leesfase',
    ud_readingTime: 'Leestijd',
    ud_fixations: 'Fixaties',
    ud_regressions: 'Regressies',
    ud_avgFixation: 'Gem. fixatie',
    ud_saccades: 'Saccaden',
    ud_blinkRate: 'Knippersnelheid',
    ud_gazeStoryTitle: "Oogtracking — Verhaalpagina's",
    ud_noStoryGaze: 'Verhaalsoogtrackinggegevens niet beschikbaar voor deze beoordeling.',
    ud_footer: 'Uw gegevens worden veilig alleen op dit apparaat opgeslagen.',
    ud_changePassword: 'Wachtwoord wijzigen',
    ud_changePasswordDesc: 'Stel een nieuw wachtwoord in voor uw account. U gebruikt het de volgende keer dat u zich aanmeldt.',
    ud_passwordUpdated: 'Wachtwoord succesvol bijgewerkt',
    ud_newPasswordPlaceholder: 'Nieuw wachtwoord (min. 4 tekens)',
    ud_saving: 'Opslaan…',
    ud_saveNewPassword: 'Nieuw wachtwoord opslaan',
    ud_passwordTooShort: 'Wachtwoord moet minimaal 4 tekens bevatten.',
    ud_passwordUpdateFailed: 'Kon uw wachtwoord niet bijwerken. Probeer het opnieuw.',
    ud_accuracySuffix: 'nauwkeurigheid',
    acp_tabCamera: 'Camera',
    acp_tabKeyboard: 'Toetsenbord',
    acp_tabMicrophone: 'Microfoon',
    acp_checkingCameraQuality: 'Camerakwaliteit controleren — dit duurt een paar seconden',
    acp_allChecksPassed: 'Alle controles geslaagd!',
    acp_allSystemsReady: 'Camera, toetsenbord en microfoon zijn gereed.',
    mini_step: 'Stap',
    scp_setupComplete: '🎉 Installatie voltooid!',
    scp_allSetSubtitle: 'U bent klaar voor de dyslexiebeoordeling',
    scp_setupQualityScore: 'Kwaliteitsscore installatie',
    scp_excellentSetup: 'Uitstekende installatiekwaliteit voor nauwkeurige beoordeling',
    scp_completedSteps: '✅ Voltooide stappen',
    scp_cameraReadiness: 'Camerareetheid',
    scp_cameraStabilityPassed: 'Stabiliteitscontrole van 10 seconden geslaagd',
    scp_keyboardCapture: 'Toetsenbordregistratie',
    scp_keystrokeData: 'Klinische toetsaanslaggegevens vastgelegd',
    scp_eyeCalibration: 'Oogkalibratie',
    scp_calibrationCompleted: 'Kalibratie voltooid ({pct}% nauwkeurigheid)',
    scp_whatsNext: 'Wat is het volgende?',
    scp_whatsNextBody: 'U begint met de leestest waarbij we uw oogbewegingen, gezichtsuitdrukkingen en leespatronen analyseren voor een uitgebreide dyslexiescreening.',
    scp_startAssessment: 'Start dyslexiebeoordeling',
    scp_startingAssessment: 'Beoordeling starten...',
    scp_estimatedTime: 'Geschatte tijd: 10-15 minuten',

    // UserDashboard rapport raster
    ud_view: 'Bekijken',
    ud_report_userInfo: 'Gebruikersinformatie',
    ud_report_envSetup: 'Omgevingsinstellingen',
    ud_report_wordIcon: 'Woord-Icoon Koppeling',
    ud_report_ran: 'RAN-analyse',
    ud_report_story: 'Verhaalanalyse',
    ud_report_wordWriting: 'Woord Schrijven',
    ud_report_feedback: 'Feedback',
    ud_report_summary: 'Samenvatting',
    ul_platform: 'Dyslexie beoordelingsplatform',
    ul_invalidCredentials: 'Ongeldig e-mailadres of wachtwoord. Controleer de gegevens die aan het einde van je beoordeling zijn getoond.',
    ul_loginFailed: 'Inloggen is mislukt. Probeer het opnieuw.',
    ul_resetFailed: 'Er is iets misgegaan. Probeer het opnieuw.',
    ul_backToSignIn: 'Terug naar inloggen',
    ul_checkEmail: 'Controleer je e-mail',
    ul_smtpDevNotice: 'SMTP niet geconfigureerd (dev). Tijdelijk wachtwoord:',
    ul_resetSent: 'Als {email} geregistreerd is, is er een nieuw wachtwoord onderweg.',
    ul_signIn: 'Inloggen',
    ul_resetPassword: 'Wachtwoord resetten',
    ul_resetPasswordDesc: 'Voer je e-mailadres in en we sturen je een nieuw wachtwoord.',
    ul_emailAddress: 'E-mailadres',
    ul_emailPlaceholder: 'jij@email.com',
    ul_sending: 'Verzenden…',
    ul_sendNewPassword: 'Nieuw wachtwoord sturen',
    ul_welcomeBack: 'Welkom terug',
    ul_signInSubtitle: 'Log in om je beoordelingsresultaten te bekijken',
    ul_password: 'Wachtwoord',
    ul_passwordPlaceholder: 'Je wachtwoord',
    ul_hidePassword: 'Wachtwoord verbergen',
    ul_showPassword: 'Wachtwoord tonen',
    ul_forgotPassword: 'Wachtwoord vergeten?',
    ul_signingIn: 'Bezig met inloggen…',
    ul_signInDashboard: 'Inloggen op je dashboard',
    ul_firstTime: 'Voor het eerst hier? Je account is automatisch aangemaakt na je beoordeling. Controleer je e-mail voor de inloggegevens.',
    ul_footer: 'AVG & MDR-conform · Geen video opgeslagen',

    mg_title: 'Even geduld voor de wetenschap!',
    mg_body: 'DysTest analyseert je oogbewegingen (op de pixel nauwkeurig!), je toetssnelheid en je geluid tot op de milliseconde nauwkeurig.\n\nSuper slimme techniek dus, maar het heeft één zwakte: het werkt niet als je scherm ondertussen heen en weer beweegt in je hand. Klap dus even een laptop of desktop open voor een betrouwbaar resultaat!',
    mg_howTo: 'Zo begin je',
    mg_step1: 'Open dystest.com op een laptop of desktop',
    mg_step2: 'Zorg dat je webcam en toetsenbord zijn aangesloten',
    mg_step3: 'Gebruik Chrome of Firefox voor het beste resultaat',
    mg_returnHome: 'Terug naar de homepage',
    mg_shareLink: 'Stuur mij de link',
    mg_copyLink: 'Link kopiëren',
    mg_linkCopied: 'Link gekopieerd',
    mg_alreadyDone: 'Al een test gedaan?',
    mg_loginLink: 'Log in om het rapport te bekijken',
    mg_emailLabel: 'Je e-mailadres',
    mg_emailPlaceholder: 'naam@voorbeeld.nl',
    mg_emailSend: 'Versturen',
    mg_emailSent: 'Verstuurd! Open de e-mail op je laptop of computer om de test te starten.',
    mg_emailError: 'De e-mail kon niet worden verstuurd. Controleer het adres en probeer het opnieuw.',
};

export default nl;
